// Экран после последнего блока. Ничего не сохраняет и никуда не шлёт —
// репетиция кончилась, у ученика тут была бы награда за урок.
import { PartyPopper } from 'lucide-react'
import { blockTheme, hsl } from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'

export const PreviewFinish = ({ onRestart }: { onRestart: () => void }) => {
  const m = useMessages(messages)
  return (
    <div
      className="flex h-full w-full flex-col items-center justify-center gap-4 px-8 text-center"
      style={{ backgroundColor: hsl(blockTheme.quizCanvas) }}
    >
      <PartyPopper className="h-10 w-10" style={{ color: hsl(blockTheme.primary) }} />
      <p className="text-lg font-semibold" style={{ color: hsl(blockTheme.quizText) }}>
        {m.finished}
      </p>
      <p className="text-sm" style={{ color: hsl(blockTheme.quizMuted) }}>
        {m.rehearsal}
      </p>
      <button
        type="button"
        onClick={onRestart}
        className="rounded-full px-5 py-2 text-sm font-semibold"
        style={{
          border: `1.5px solid ${hsl(blockTheme.quizIdleBorder)}`,
          color: hsl(blockTheme.quizOptionText),
        }}
      >
        {m.again}
      </button>
    </div>
  )
}
